import { AxiosResponse } from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Pagination } from "rsuite";

import { Button, Card, Col, Row } from "react-bootstrap";
import { toast } from "react-toastify";
import {
  EPDateRangePicker,
  EPTable,
  EPTagPicker,
} from "../../../common/controls";
import { getAllProjects, getProjectListData } from "../../../common/utils/api";
import { CommonConstants } from "../../../common/utils/CommonConstants";
import { axiosDelete, axiosGet } from "../../../common/utils/helper";
import { UserContext } from "../../layout/layout";
import AddProjectModal from "./AddProjectModal";

const Project = () => {
  const { user }: any = useContext(UserContext);
  const PageAccess: string[] =
    user.RoleAccess[location.pathname?.split("/").join("").toLowerCase()];
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [ProjectList, setProjectList] = useState([]);
  const [projectListInDropdown, setProjectListInDropDown] = useState([]);
  const [refresher, setRefresher] = useState<boolean>(false);
  const [filterData, setFilterData] = useState<any>({});
  const [limit, setLimit] = useState(10);
  const [pageNo, setPageNo] = useState(1);
  const [totalRecords, setTotalRecords] = useState(100);

  const tableColumns = [
    {
      key: "Action",
      label: "Action",
      width: 100,
    },
    {
      key: "ProjectName",
      label: "Project Name",
      sortable: true,
      resizable: true,
      width: 200,
    },
    {
      key: "CompanyName",
      label: "Company Name",
      sortable: true,
      resizable: true,
      width: 200,
    },
    {
      key: "ClientName",
      label: "Client Name",
      sortable: true,
      resizable: true,
      width: 180,
    },
    {
      key: "ProjectStartDate",
      label: "Project Start Date",
      sortable: true,
      resizable: true,
      width: 170,
    },
    {
      key: "ProjectEndDate",
      label: "Project End Date",
      sortable: true,
      resizable: true,
      width: 170,
    },
    {
      key: "CreatedBy",
      label: "Created By",
      sortable: true,
      resizable: true,
      width: 180,
    },
  ];
  interface sortData {
    sortColumn: string;
    sortType: string;
  }
  const [sortData, setSortData] = useState<sortData>({
    sortColumn: "createdAt",
    sortType: "desc",
  });

  let response;
  const getProjectList = async (
    reqUrl: string,
    pageNo: number,
    limit: number,
    sortData: sortData,
    filterData?: any
  ) => {
    setLoading(true);
    let reqBody = {
      pageNumber: pageNo,
      limit: limit,
      sortBy: `${sortData.sortColumn}:${sortData.sortType}`,
      filter: JSON.stringify(filterData),
    };
    response = (await axiosGet(reqUrl, reqBody)) as AxiosResponse;

    if (
      response &&
      response.status === CommonConstants.API_RESPONSE_SUCCESSFULL
    ) {
      setLoading(false);
      setProjectList(response?.data?.data?.ProjectData);
      setTotalRecords(response?.data?.data?.length);
    }
  };

  async function getProjectListInDropdown(reqUrl: string) {
    response = (await axiosGet(reqUrl, {})) as AxiosResponse;
    setProjectListInDropDown(response?.data?.data?.data);
  }

  useEffect(() => {
    getProjectListInDropdown(getAllProjects);
  }, [refresher]);

  useEffect(() => {
    getProjectList(getProjectListData, pageNo, limit, sortData, filterData);
  }, [pageNo, refresher, filterData]);

  async function DeleteFunction(reqUrl: string, Id: number) {
    response = (await axiosDelete(`${reqUrl}/${Id}`)) as AxiosResponse;
    if (response.status === CommonConstants.API_RESPONSE_SUCCESSFULL) {
      toast.success("Project Deleted successfully", {
        position: toast.POSITION.TOP_CENTER,
      });

      // Refresh the dataset based on the current filter
      if (filterData?.ProjectID?.includes(Id)) {
        // Remove the deleted record from the filter array
        let updatedFilterData = { ...filterData };
        updatedFilterData.ProjectID = updatedFilterData?.ProjectID?.filter(
          (projectId: any) => projectId !== Id
        );

        setFilterData(updatedFilterData);
      }
      refresher ? setRefresher(false) : setRefresher(true);
    }
  }

  function handleAddProjectModal() {
    setOpen(true);
  }

  const handleOnChange = (value: string | number, name: string) => {
    let data = { ...filterData };
    data[name] = value;
    setFilterData(data);
    setPageNo(1);
  };

  const handleSortColumn = (sortColumn: string, sortType: string) => {
    sortData["sortColumn"] = sortColumn;
    sortData["sortType"] = sortType;
    const updatedSortData = {
      ...sortData,         // Spread the previous state (this maintains other properties intact)
      sortColumn,          // Update the sortColumn value
      sortType             // Update the sortType value
    };
    setSortData(updatedSortData);
    setLoading(true);
    setPageNo(1);
    getProjectList(getProjectListData, pageNo, limit, sortData, filterData);
  };

  return (
    <Card className="card-managerequest managerequest">
      <Card.Body>
        <div>
          {open && (
            <AddProjectModal
              open={open}
              setOpen={setOpen}
              action={"Add"}
              setRefresher={setRefresher}
              refresher={refresher}
            />
          )}
        </div>
        <Row className="m-1 mb-3">
          <Col xs={12} md={6} lg={3} className="tagpicker-blk">
            <EPTagPicker
              label="Project"
              placeholder="Search Project"
              data={projectListInDropdown}
              onChange={(val: number) => handleOnChange(val, "ProjectID")}
              value={filterData?.ProjectID}
              displayCount={true}
            />
          </Col>

          <Col xs={12} md={6} lg={3} className="tagpicker-blk ">
            <EPDateRangePicker
              placeholder="Project Date Range"
              onChange={(date: any) => handleOnChange(date, "ProjectDate")}
              value={
                filterData?.ProjectDate
                  ? filterData.ProjectDate.map(
                      (dateString: any) => new Date(dateString)
                    )
                  : null
              }
            />
          </Col>

          {(PageAccess?.includes("Add") || PageAccess?.includes("All")) && (
            <Col xs lg="3" className="text-end ms-auto">
              <Button type="button" onClick={handleAddProjectModal}>
                Add Project
              </Button>
            </Col>
          )}
        </Row>
        <div className="px-3">
          <EPTable
            setLoading={setLoading}
            PageAccess={PageAccess}
            listName="ProjectList"
            columns={tableColumns}
            data={ProjectList}
            functionMethod={DeleteFunction}
            sortColumn={sortData.sortColumn}
            sortType={sortData.sortType}
            onSortColumn={handleSortColumn}
            loading={loading}
            rowHeight={40}
            height={455}
            refresher={refresher}
            setRefresher={setRefresher}
          />

          {
            <div style={{ paddingTop: 20 }}>
              <Pagination
                prev
                next
                ellipsis // display 3 dots
                boundaryLinks
                maxButtons={5}
                size="xs"
                layout={["total", "-", "pager"]}
                total={totalRecords}
                limit={limit}
                activePage={pageNo}
                onChangePage={setPageNo}
              />
            </div>
          }
        </div>
      </Card.Body>
    </Card>
  );
};

export default Project;
